import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

export default function ShowProgress() {
  const classes = useStyles();
  const showMe = useSelector((state) => state.showProgress);

  return (
    <div>
      <Backdrop className={classes.backdrop} open={showMe}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
